import { useState } from "react";
import { DomShell } from "./_gameKit";
import AdReward from "./_adReward";

const CHOICES = [
  { k: "rock", label: "Rock", emoji: "✊" },
  { k: "paper", label: "Paper", emoji: "🖐️" },
  { k: "scissors", label: "Scissors", emoji: "✌️" },
];

function winner(a, b) {
  if (a === b) return "draw";
  if ((a === "rock" && b === "scissors") || (a === "paper" && b === "rock") || (a === "scissors" && b === "paper")) return "you";
  return "ai";
}

export default function JixxeoRPS() {
  const [you, setYou] = useState(0);
  const [ai, setAi] = useState(0);
  const [round, setRound] = useState(0);
  const [last, setLast] = useState(null);
  const [locked, setLocked] = useState(false);
  const target = 3;
  const setDone = you >= target || ai >= target;

  const play = (k) => {
    if (locked || setDone) return;
    setLocked(true);
    const aiPick = CHOICES[Math.floor(Math.random() * 3)].k;
    setTimeout(() => {
      const w = winner(k, aiPick);
      setLast({ you: k, ai: aiPick, w });
      if (w === "you") setYou((n) => n + 1);
      else if (w === "ai") setAi((n) => n + 1);
      setRound((n) => n + 1);
      setLocked(false);
    }, 550);
  };

  const restart = () => { setYou(0); setAi(0); setRound(0); setLast(null); };

  return (
    <DomShell title="Jixxeo Rock Paper Scissors" accent="#FF003C"
      chips={[["You", you], ["AI", ai], ["Round", round]]}
      instructions="First to 3 wins the set"
    >
      <div className="flex items-center justify-around py-6">
        <div className="text-center">
          <div className="mono text-[10px] uppercase text-[#00F0FF] mb-2">// you</div>
          <div className="text-6xl">{last ? CHOICES.find((c) => c.k === last.you).emoji : "❔"}</div>
        </div>
        <div className="mono text-2xl text-white/50">vs</div>
        <div className="text-center">
          <div className="mono text-[10px] uppercase text-[#FF003C] mb-2">// ai</div>
          <div className="text-6xl">{last ? CHOICES.find((c) => c.k === last.ai).emoji : "❔"}</div>
        </div>
      </div>
      {last && !setDone && (
        <div className="text-center font-heading font-black text-2xl uppercase tracking-tighter mb-4"
          style={{ color: last.w === "you" ? "#39FF14" : last.w === "ai" ? "#FF003C" : "#FFE300" }}>
          {last.w === "you" ? "You win the round" : last.w === "ai" ? "AI wins the round" : "Draw"}
        </div>
      )}
      {setDone ? (
        <div className="text-center space-y-3">
          <div className="font-heading font-black text-3xl uppercase tracking-tighter"
            style={{ color: you > ai ? "#39FF14" : "#FF003C" }}>
            {you > ai ? "SET WON ⚡" : "SET LOST"}
          </div>
          <div className="flex justify-center"><AdReward game="jixxeo-rps" compact /></div>
          <button onClick={restart} className="mono text-[10px] uppercase tracking-widest bg-white/10 hover:bg-white/20 text-white font-black px-5 py-2 rounded-full">
            Rematch
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-3">
          {CHOICES.map((c) => (
            <button key={c.k} disabled={locked} onClick={() => play(c.k)}
              className="rounded-2xl border-2 border-[#FF003C]/30 hover:border-[#FF003C]/70 bg-[#FF003C]/5 hover:bg-[#FF003C]/20 py-4 flex flex-col items-center gap-1 disabled:opacity-50 transition-colors">
              <span className="text-3xl">{c.emoji}</span>
              <span className="mono text-[10px] uppercase tracking-widest text-white/70">{c.label}</span>
            </button>
          ))}
        </div>
      )}
    </DomShell>
  );
}
